<template>
  <div class="row">
    <div v-for="image in images" :key="image"  class="px-2 py-2 col-lg-4 col-md-6">
    <img :src="image.src" class="galery-img" fluid :alt="image.alt" :title="image.title" loading="lazy"/>
  </div>
  </div>
</template>
<script>

export default {
  name: 'ImageGalery',

  components: {
    
  },
  props: {
    images:
    {
    type: Array,
    // Object or array defaults must be returned from
    // a factory function. The function receives the raw
    // props received by the component as the argument.
    default() {
      return [
       {
        src: require('@/assets/iStock-622277572.webp'),
        title: "Ihr Umzugsunternehmen in der Nähe",
        alt: "Ihr Umzugsunternehmen in der Nähe",
      }
    ]
    }
    
    }
  },
  data() {
    return {
    };
  }
}
</script>
<style>
.galery-img{
   width: 100%;
   height: 100%;
 }
</style>